module.exports = __webpack_public_path__ + "static/3_1_eyes-6058ccaad61e3fc6a51d117960434bc8.svg";